var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDangerTriangle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5C24.8284 14.5 25.5 15.1716 25.5 16V26C25.5 26.8284 24.8284 27.5 24 27.5C23.1716 27.5 22.5 26.8284 22.5 26V16C22.5 15.1716 23.1716 14.5 24 14.5Z",
    fill: "url(#paint0_linear_2696_13686)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34C25.1046 34 26 33.1046 26 32C26 30.8954 25.1046 30 24 30C22.8954 30 22 30.8954 22 32C22 33.1046 22.8954 34 24 34Z",
    fill: "url(#paint1_linear_2696_13686)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5888 8.95286C18.7326 6.22986 21.0036 4.5 24 4.5C26.9962 4.5 29.2672 6.22986 31.4112 8.95286C33.5196 11.6309 35.7538 15.5924 38.6126 20.661L39.4836 22.2054C41.8468 26.3952 43.7132 29.7046 44.6936 32.3608C45.6956 35.0752 45.9336 37.5398 44.418 39.7138C42.9472 41.8236 40.4932 42.6868 37.3982 43.0942C34.3152 43.5 30.169 43.5 24.8496 43.5H23.1504C17.831 43.5 13.6848 43.5 10.6016 43.0942C7.50662 42.6868 5.05274 41.8236 3.58198 39.7138C2.06636 37.5398 2.30436 35.0752 3.30628 32.3608C4.28668 29.7046 6.15316 26.3954 8.51636 22.2054L9.38722 20.6614C12.246 15.5926 14.4804 11.6309 16.5888 8.95286ZM18.9459 10.8086C16.9979 13.283 14.8741 17.0398 11.9299 22.2598L11.2026 23.5494C8.75014 27.8976 7.00736 30.9972 6.12068 33.3996C5.2454 35.771 5.36676 37.0282 6.04296 37.9982C6.76404 39.0326 8.11746 39.7412 10.9932 40.1198C13.8572 40.4968 17.8052 40.5 23.2726 40.5H24.7272C30.1948 40.5 34.1428 40.4968 37.0068 40.1198C39.8824 39.7412 41.2358 39.0326 41.957 37.9982C42.6332 37.0282 42.7546 35.771 41.8792 33.3996C40.9926 30.9972 39.2498 27.8976 36.7974 23.5494L36.07 22.2598C33.1258 17.0397 31.002 13.283 29.054 10.8086C27.124 8.3573 25.6252 7.5 24 7.5C22.3748 7.5 20.8758 8.3573 18.9459 10.8086Z",
    fill: "url(#paint2_linear_2696_13686)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2696_13686",
    x1: 24,
    y1: 4.5,
    x2: 24,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A55C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2696_13686",
    x1: 24,
    y1: 4.5,
    x2: 24,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A55C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2696_13686",
    x1: 24,
    y1: 4.5,
    x2: 24,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A55C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDangerTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/danger_triangle.348f2c4f.svg";
export { ForwardRef as ReactComponent };